import './HvacFormSectionFormBlock.scss';
import { EnergyEfficiencyClass } from '@belimo-retrofit-portal/logic';
import React from 'react';
import { EnergyEfficiencyLabel } from 'src/modules/common/components/EnergyEfficiencyLabel';
import { LABELS } from 'src/modules/common/constants/energyEfficiencyLabels';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { LeadText } from 'src/modules/common/typography/LeadText';

type Props = {
  readonly title: React.ReactNode;
  readonly label: React.ReactElement | null;
  readonly children: React.ReactNode;
};

export const HvacFormSectionFormBlock = ({ title, label, children }: Props): React.ReactElement => (
  <div className="bp-hvac-form-section-form-block">
    <div className="bp-hvac-form-section-form-block__version">
      <BodyMedium01>
        {title}
      </BodyMedium01>

      {label && (
        <div className="bp-hvac-form-section-form-block__label">
          {label}
        </div>
      )}
    </div>

    <div className="bp-hvac-form-section-form-block__content">
      {children}
    </div>
  </div>
);
